import useWindowWidth from "./useWindowWidth";

const useGetChartWidth = (size) => {
  const { width } = useWindowWidth();
  const fixedWidth = width - 200;
  return (fixedWidth / 12) * size - 15;
};
export default useGetChartWidth;
